import { LegalContent } from './LegalContent';
import { LegalPage } from './LegalPage';
import { PRIVACY_POLICY_CONTENT } from './privacyPolicyContent';

export function PrivacyPolicyPage() {
  return (
    <LegalPage title="Privacy Policy" updated="Last updated: September 2025">
      <LegalContent blocks={PRIVACY_POLICY_CONTENT} />
    </LegalPage>
  );
}
